{
    "translation": {
        "welcome": "أهلاً بك",
        "home": "الرئيسية",
        "find_pro": "ابحث عن محترف",
        "admin": "مسؤول",
        "my_space": "مساحتي",
        "login": "تسجيل الدخول",
        "logout": "تسجيل الخروج",
        "search_placeholder": "حلاق، حلاقة، مانيكير...",
        "hero_welcome": "مرحباً بك في OpenGlow",
        "hero_slogan": "التميز في متناول يدك.",
        "hero_desc": "احجز علاجات التجميل والعافية الخاصة بك بنقرات قليلة. بسيط وسريع وأنيق.",
        "hero_title": "احجز موعد تجميلك",
        "hero_subtitle": "اعثر على أفضل المحترفين بالقرب منك.",
        "search_btn": "بحث",
        "popular_services": "الخدمات الشائعة",
        "footer_rights": "جميع الحقوق محفوظة.",
        "footer_about_us": "من نحن",
        "legal_mentions": "إشعارات قانونية",
        "cgp": "الشروط العامة للخدمة",
        "feature_search_title": "بحث",
        "feature_search_desc": "اعثر على أفضل الصالونات والخبراء بالقرب منك",
        "feature_book_title": "حجز",
        "feature_book_desc": "اختر فترتك المثالية في ثوانٍ",
        "feature_enjoy_title": "استمتع",
        "feature_enjoy_desc": "عش تجربة تجميل فريدة ومريحة",
        "featured_pros_title": "محترفون مميزون",
        "reviews_count": "تقييمات",
        "client_space": "منطقة العميل",
        "my_bookings": "حجوزاتي",
        "explore_map": "استكشاف الخريطة",
        "edit_photo": "تعديل الصورة",
        "photo_updated": "تم تحديث صورة الملف الشخصي!",
        "error_upload": "خطأ في تحميل الصورة.",
        "search_action": "بحث",
        "filters_all": "الكل",
        "filter_sort": "الفلاتر",
        "filter_distance_nearest": "المسافة: الأقرب",
        "filter_rating_highest": "التقييم: الأعلى",
        "filter_reviews_most": "المراجعات: الأكثر",
        "filter_name_az": "الاسم: أ-ي",
        "filter_min_rating": "أدنى تقييم",
        "filter_max_distance": "أقصى مسافة",
        "show_filters": "إظهار الفلاتر",
        "hide_filters": "إخفاء الفلاتر",
        "map_style": "النمط",
        "map_enable_location_filter": "فعّل الموقع للتصفية حسب المسافة",
        "profession_hairdresser": "مصفف شعر",
        "profession_esthetician": "اختصاصي تجميل",
        "profession_barber": "حلاق",
        "profession_manicure": "مانيكير",
        "profession_masseur": "مدلك",
        "settings_title": "الإعدادات",
        "settings_back": "رجوع",
        "settings_section_appearance": "المظهر",
        "settings_theme_intro": "اختر سمة التطبيق.",
        "settings_theme_classic": "أبيض وأسود",
        "settings_theme_ocean": "المحيط",
        "settings_theme_rose": "وردي",
        "settings_theme_dark": "داكن",
        "settings_theme_night": "ليلي",
        "settings_compact_mode": "الوضع المضغوط",
        "settings_compact_mode_sub": "يقلل المسافات في هذه الصفحة",
        "settings_section_notifications": "الإشعارات",
        "settings_notif_email": "رسائل الحجز",
        "settings_notif_email_sub": "تأكيدات وتذكيرات المواعيد",
        "settings_notif_push": "مركز الإشعارات",
        "settings_notif_push_sub": "تنبيهات داخل التطبيق",
        "settings_notif_marketing": "الأخبار والعروض",
        "settings_notif_marketing_sub": "تحديثات المنتج والعروض الترويجية",
        "settings_section_account": "الحساب",
        "settings_account_profile": "الملف الشخصي",
        "settings_account_email_label": "عنوان البريد الإلكتروني",
        "settings_not_connected": "غير متصل",
        "settings_section_security": "الأمان",
        "settings_pwd_title": "تغيير كلمة المرور",
        "settings_pwd_hint": "اختر كلمة مرور قوية (12+ حرف، كبير، رقم، رمز)",
        "settings_pwd_current": "كلمة المرور الحالية",
        "settings_pwd_new": "كلمة المرور الجديدة",
        "settings_pwd_confirm": "تأكيد كلمة المرور الجديدة",
        "settings_pwd_submit": "حفظ كلمة المرور",
        "settings_pwd_submitting": "جارٍ الحفظ…",
        "about_title": "من نحن",
        "about_intro": "OpenGlow منصة فرنسية تسهل الربط بين العملاء ومحترفي التجميل.",
        "about_mission_title": "مهمتنا",
        "about_mission_text": "مساعدة كل شخص على العثور بسرعة على محترف موثوق قريب منه، مع تجربة حجز بسيطة وشفافة وحديثة.",
        "about_build_title": "ما الذي نبنيه",
        "about_build_item_1": "مساحة عميل واضحة للبحث والحجز ومتابعة المواعيد.",
        "about_build_item_2": "مساحة للمحترف لإدارة الجدول والخدمات والتقييمات والإعلانات.",
        "about_values_title": "قيمنا",
        "about_values_simple_label": "البساطة:",
        "about_values_simple_text": "واجهة سريعة وسهلة الفهم للجميع.",
        "about_values_trust_label": "الثقة:",
        "about_values_trust_text": "معلومات واضحة وملفات موثقة.",
        "about_values_respect_label": "الاحترام:",
        "about_values_respect_text": "حماية البيانات الشخصية ونهج مسؤول.",
        "about_values_exigence_label": "التميز:",
        "about_values_exigence_text": "تحسين مستمر لتجربة المستخدم.",
        "about_contact_title": "التواصل",
        "about_contact_line_1": "هل لديك سؤال أو تحتاج إلى مساعدة؟",
        "about_contact_line_2": "يرجى استخدام الدردشة الداخلية في الموقع للحصول على رد أسرع.",
        "about_contact_line_3": "ولأي طلب آخر، راسلنا على",
        "settings_show_pwd": "إظهار",
        "settings_hide_pwd": "إخفاء",
        "passwords_mismatch": "كلمتا المرور غير متطابقتين.",
        "password_change_success": "تم تغيير كلمة المرور بنجاح.",
        "password_change_error": "خطأ أثناء تغيير كلمة المرور.",
        "network_error_retry": "خطأ في الشبكة. يرجى المحاولة مرة أخرى."
    }
}